<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Claims' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div class="d2c-class-container" style="padding-top: 77px;">
              <!-- Nav tabs -->
              <h2 class="listing-page-title">Claim Detail</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <div class="row-tab-content container detail-view-box" id="myTabContent">
        <div class="row detail-header ib-align-start">
          <div class="col-md-6 col-lg-4 col-xl-3">
            <div class="detail-header-img">
              <div>
                <img class="img-fluid" :src="policy_detail.product.product_image" v-if="policy_detail.product.plan_name == ''" />
                <img class="img-fluid" :src="policy_detail.product.plan_image" v-if="policy_detail.product.plan_name != ''" />
              </div>
              <div class="header-circle-img">
                <img class="img-fluid" :src="policy_detail.company.logo">
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-7 pl-lg-0">
            <h3 class="header-title">{{ policy_detail.product.product_name }}
              <small>{{ policy_detail.insurance_sub_type }}</small>

              <small class="ib-card-plan font-10" v-if="policy_detail.product.plan_name != ''">{{ policy_detail.product.plan_name }}</small>
            </h3>
            <div class="" v-if="policy_detail.policy_no != null" style="display: flex">
              <p class="header-td-first" style="margin: 0 ">Policy No: <span>{{ policy_detail.policy_no }}</span></p>
              <p class="header-td-first" style="margin-left: 32px;">Claim No: <span>{{ claim_detail.claim_no }}</span></p>
            </div>
            <div class="" v-else>
              <p class="header-td-first">Order No: <span>{{ policy_detail.tcn_no }}</span></p>
            </div>
            <div class="" v-if="policy_detail.policy_no != null">
              <p class="header-td-first">Order Date: <span>{{ formatDate(policy_detail.created_at) }}</span></p>
            </div>
            <div class="">
              <p class="header-td-first">{{ Insured }} Amount: <span>{{ policy_detail.currency }} </span><span style="color: #3d9cbd !important;">{{ priceFormatter(policy_detail.sum_insured) }}</span></p>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="status-in-process text-capitalize mb-3">{{ claim_detail.status }}</div>
            <div class="">
              <p class="header-td-first">Expiring Premium:</p>
              <h3 class="header-price">{{ policy_detail.currency }}<span>&nbsp;{{ priceFormatter(policy_detail.paid_amount) }}</span></h3>
            </div>
          </div>
        </div>

        <div class="row ib-default-flex my-3 in-listing-tabs" style="margin-top: 1.5rem !important;">
          <ul class="nav nav-tabs jbl-nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">Policy Detail</a>
            </li>
            <li class="nav-item">
              <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Other Detail</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="claim-tab" data-toggle="tab" href="#claim" role="tab" aria-controls="claim" aria-selected="false">Claim Detail</a>
            </li>
          </ul>
        </div>

        <div class="col-md-12 tab-pane fade active show" id="home" role="tabpanel" aria-labelledby="home-tab">
          <div class="row px-1">
            <h2 class="claim-sub-heading primary-color pl-2">{{ customer }} Information</h2>
            <table class="table table-borderless">
              <tr  v-for="(insurer,  index) in chunkedData(insurer_detail)" :key="index">
                <td  v-for="(detail, ind) in insurer" :key="ind">
                  <p class="claim-row-data claim-row-sub-heading">{{ detail.label }} </p>
                  <dd class="claim-row-data" v-if="detail.label.toLowerCase().includes('date') || detail.label.toLowerCase().includes('dob')">{{ formatDynamicDate(detail.value)}}</dd>
                  <dd class="claim-row-data" v-else>{{ detail.value }}</dd>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!--Beneficiary Detail-->
        <div class="col-md-12 tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
          <h2 class="claim-sub-heading primary-color">Beneficiary Information</h2>
          <div class="accordion" id="accordionExample">
            <div class="card" v-for="(beneficiary, key) in beneficiaries">
              <div class="jbl-card-header jbl-policy-accordion" :id="'headingOne'+key">
                <h2 class="mb-0" data-toggle="collapse" :data-target="'#collapseOne'+key" aria-expanded="true" aria-controls="collapseOne">
                  <button class="btn btn-link jbl-default-flex" type="button">
                     <!-- style="width: 35px; height: 35px;"  -->
                    <img :src="require('@/assets/images/jbl-accordion-img-2x.png')" alt="Image">
                    Beneficiary no.{{ key+1 }}
                    <span v-if="beneficiary.is_primary_beneficiary == 1">Primary</span>
                  </button>
                </h2>
              </div>
              <div :id="'collapseOne'+key" class="collapse" :aria-labelledby="'headingOne'+key" data-parent="#accordionExample">
                <div class="card-body jbl-card-inner">
                  <table class="table table-borderless">
                    <tr>
                      <td>
                        <p class="claim-row-data claim-row-sub-heading">First Name</p>
                        <dd class="claim-row-data">{{ beneficiary.first_name }}</dd>
                      </td>
                      <td>
                        <p class="claim-row-data claim-row-sub-heading">Middle Name</p>
                        <dd class="claim-row-data">{{ beneficiary.middle_name }}</dd>
                      </td>
                      <td>
                        <p class="claim-row-data claim-row-sub-heading">Last Name</p>
                        <dd class="claim-row-data">{{ beneficiary.last_name }}</dd>
                      </td>
                      <td>
                        <p class="claim-row-data claim-row-sub-heading">Beneficiary CNIC</p>
                        <dd class="claim-row-data">{{ beneficiary.cnic }}</dd>
                      </td>
                      <td>
                        <p class="claim-row-data claim-row-sub-heading">Relation</p>
                        <dd class="claim-row-data">{{ beneficiary.relation.text }}</dd>
                      </td>
                      <td>
                        <p class="claim-row-data claim-row-sub-heading">Beneficiary Share</p>
                        <dd class="claim-row-data">{{ beneficiary.percentage }}%</dd>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="claim-row-data claim-row-sub-heading">Mobile Number</p>
                        <dd class="claim-row-data">{{ beneficiary.mobile_no }}</dd>
                      </td>
                      <td>
                        <p class="claim-row-data claim-row-sub-heading">Email</p>
                        <dd class="claim-row-data">{{ beneficiary.email }}</dd>
                      </td>
                      <td>
                        <p class="claim-row-data claim-row-sub-heading">Address</p>
                        <dd class="claim-row-data">{{ beneficiary.address }}</dd>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 tab-pane fade " id="contact" role="tabpanel" aria-labelledby="contact-tab">
          <div class="row px-3">
            <h2 class="claim-sub-heading">Quotation Detail</h2>
            <table class="table table-borderless">
              <tr v-for="data in chunked" >
                <td v-for="(item, key) in data">
                  <p class="claim-row-data claim-row-sub-heading">{{ item.label }}</p>
                  <dd class="claim-row-data" v-if="item.label == 'Vehicle Value'">{{ priceFormatter(item.value)}}</dd>
                  <dd class="claim-row-data" v-else-if="item.label.toLowerCase().includes('date') || item.label.toLowerCase().includes('dob')">{{ formatDynamicDate(item.value)}}</dd>
                  <dd class="claim-row-data" v-else>{{ item.value }}</dd>
                </td>
              </tr>
            </table>
          </div>
          <div class="row px-3">
            <h2 class="claim-sub-heading primary-color">Policy Documents</h2></div>
          <div class="row" v-for="document in risk_detail.documents">
            <div class="col-md-12">
              <div class="row px-3">
                <h4 class="documents-heading">{{ document.text.replace(/_/g,' ')}}</h4>
              </div>
              <div class="row in-document-flex">
                <div class="claim-doc-icon" v-for="(key, index) in document.urls">
                  <a :href="key.url" target="_blank">
                    <div class="claim-data-icon">
                      <img :src="require('@/assets/images/file.png')">
                      <p>Document {{ index+1 }}</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 tab-pane fade" id="claim" role="tabpanel" aria-labelledby="claim-tab">
          <div class="row px-3">
            <h2 class="claim-sub-heading primary-color">Claim Information</h2>
            <table class="table table-borderless">
              <tr>
                <td  v-for="item in claim_detail_tabel_data">
                  <p class="claim-row-data claim-row-sub-heading">{{ item.label }}</p>
                  <dd class="claim-row-data">{{ item.value}}</dd>
                </td>
              </tr>
            </table>
          </div>
          <div class="row px-3">
            <h2 class="claim-sub-heading primary-color" v-if="claim_detail.documents.length > 0">Uploaded documents</h2>
          </div>
          <div class="row" v-for="document in claim_detail.documents" v-if="claim_detail.documents.length > 0">
            <div class="col-md-12">
              <div class="row in-document-flex">
                <div class="claim-doc-icon" v-for="(key, index) in document.urls">
                  <a :href="key.url" target="_blank">
                    <div class="claim-data-icon">
                      <img :src="require('@/assets/images/file.png')">
                      <p>Document {{ index+1 }}</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row px-3">
            <h2 class="claim-sub-heading primary-color" v-if="claim_detail.claim_document != ''">Claim Document</h2>
          </div>
          <div class="row" v-if="claim_detail.claim_document != ''">
            <div class="col-md-12">
              <div class="row in-document-flex">
                <div class="claim-doc-icon">
                  <a :href="claim_detail.claim_document" target="_blank">
                    <div class="claim-data-icon">
                      <img :src="require('@/assets/images/file.png')">
                      <p>Claim Document</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row px-3">
            <h2 class="claim-sub-heading primary-color" v-if="claim_detail.images.length > 0">Images</h2>
          </div>
          <div class="row" v-if="claim_detail.images.length > 0">
            <div class="col-md-12">
              <div class="row in-document-flex">
                <div v-for="img in claim_detail.images" class="claim-doc-icon">
                    <div class="claim-data-icon">
                      <img :src="img.url">
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'
  import moment from "moment";
  import _ from "lodash";

  export default {
    name: 'ClaimsView',
    components: {
      loading
    },
    data () {
      return {
        showLoader: false,
        beneficiaries_area: false,
        claim_detail: {},
        claim_detail_tabel_data: {},
        policy_detail: {},
        insurer_detail: {},
        beneficiaries: {},
        customer: 'customer',
        Insured : 'Insured',
        SuInsured : 'Sum Insured',
        NetPremium : 'Net Premium',
        GrossPremium : 'Gross Premium',
        Coverage : 'Coverages',
        FIF: 'FIF'
      };
    },
    created: function () {
      const self = this;
      self.getClaim(self.$route.params.id);
    },
    computed: {
      chunked() {
        return _.chunk(this.risk_detail.form_data.stage_1,4);
      },
    },

    methods: {
      replaceString(){
        const self = this;
        self.customer =  'Participant';
        self.Insured = 'Participant';
        self.SuInsured = 'Sum Covered';
        self.NetPremium = 'Net Contribution';
        self.GrossPremium = 'Gross Contribution';
        self.Coverage = 'Benefits';
        self.FIF = 'FTF';
      },
      priceFormatter(price) {
        return new Intl.NumberFormat('en-PK').format(price);
      },
      chunkedData(data) {
        return _.chunk(data,4);
      },
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
      },
      formatDynamicDate(date) {
        return moment(date, 'YYYY-MM-DD').format('DD-MMM-YYYY');
      },
      async getClaim(id) {
        var self = this;
        self.showLoader = true;
        await axios.get('customer/claim_details?claim_id=' + id).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.claim_detail_tabel_data = resp.data.data.form_data;
            self.claim_detail = resp.data.data;
            self.getPolicy(self.claim_detail.quotation.id);
            // self.insurerDetail(self.claim_detail.quotation.id);
            self.BeneficiaryDetail(self.claim_detail.quotation.id);
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async getPolicy(id) {
        var self = this;
        self.showLoader = true;
        await axios.get('customer/policy_detail?id=' + id).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.policy_detail = resp.data.data
            let risk_id = resp.data.data.risks[0].id;

            axios.get('customer/risk_detail?customer_quotation_id=' + id + '&quotation_risk_id=' +risk_id).then(function (response) {
              if (response.data.code == 200) {
                self.risk_detail = response.data.data;
                self.insurer_detail = response.data.data.form_data.stage_3;
                // self.stage_1 = self.chunkedData(self.risk_detail.form_data.stage_1);
                // self.FilterDate(self.risk_detail.form_data.stage_3);

                self.showLoader = false;
              }
            });
            if (self.policy_detail.is_takaful == 1){
              self.replaceString();
            }
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async insurerDetail(id) {
        var self = this;
        self.showLoader = true;
        await axios.get('customer/quotation/customer_details?quotation_id=' + id).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.insurer_detail = resp.data.data;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async BeneficiaryDetail(id) {
        var self = this;
        self.showLoader = true;
        await axios.get('customer/policy_beneficiaries?policy_id=' + id).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.beneficiaries = resp.data.data;
            if (self.beneficiaries.length !== 0){
              self.beneficiaries_area = true;
            }
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      }
    }
  };
</script>

<style scoped>
  .active {
    display: block !important;
  }
  .tab-pane {
    display: none;
  }
  .primary-color {
    color: #007bff !important;
  }
  .claim-doc-icon p {
    font-family: "Avenir Medium";
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #4c505d;
    margin-bottom: 0px;
  }
  .claim-data-icon img {
    margin: 0 auto;
  }
  /* .claim-data-icon {
    width: 131px;
    height: 134px;
    border-radius: 10px;
    border: solid 1px #e5e5e5;
    background-color: #ffffff;
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
    display: flex !important;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
  }
  .claim-data-icon:not(:nth-of-type(1)){
    margin-left: 15px;
    margin-right: 15px;
  } */
  .claim-row-sub-heading {
    font-family: "Avenir Book";
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: left;
    padding-left: 20px;
    color: #ef7c94;
    color: #ef7c94 !important;
  }
  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
    border: solid 1px transparent;
    color: #fff !important;
    height: 61px;
    border-radius: 31px;
    background-color: #def3f7;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
    border: solid 1px var(--primary-color);
    background-color: var(--primary-color);
    color: #fff !important;
    height: 61px;
    border-radius: 31px;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
  .jbl-nav-tabs .nav-item .nav-link {
    color: #5b6770;
  }
  .jbl-nav-tabs {
    border-radius: 31px;
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    background-color: #def3f7;
    border: 0;
    font-family: "Avenir Medium";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
    margin: 20px 0 10px 15px;
    /* padding-top: 1px;
    padding-bottom: 1px; */
  }
  table > tbody > tr, .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    border: solid 1px #dedada;
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .claim-sub-heading {
    width: 100%;
    min-height: 54px;
    margin: 20px 0px;
    padding: 16px;
    border-radius: 7px;
    /* border: dotted 2px #3d9cbd; */
    border: dashed 3px #3d9cbd;
    background-color: rgba(61, 156, 189, 0.03);
    font-family: "Avenir Heavy";
    font-size: 16px;
    /* font-weight: 900; */
    text-align: left;
    color: #ef7c94 !important;
  }
  .data-row .claim-sub-heading {
    font-family: "Avenir Heavy";
    font-size: 16px;
    /* font-weight: 900; */
    text-align: left;
    color: #ef7c94 !important;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Avenir Medium";
  }
  .data-row .claim-row-data {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.37;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  .data-row .claim-row-heading {
    font-family: "Avenir Medium";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  label {
    position: absolute;
    top: 0;
    right: 1px;
    bottom: 1px;
    left: .5em;
    z-index: 1;
    height: 1em;
    font-size: 13px;
    line-height: 3.5em;
    color: #999;
    white-space: nowrap;
    cursor: text;
    transition:all .1s ease;
  }
  .input-placeholder:focus ~ label, .input-placeholder:valid ~label {
    font-size:11px;
    left:10px;
    top:-10px;
  }
  .input-placeholder:valid ~label {
    color:green;
  }
  .input-placeholder:focus:invalid ~label {
    color:red;
  }
  .table.table-borderless td {
    padding: 1rem 0rem;
  }
  @media (max-width:576px) {
    nav.nav-tabs.jbl-nav-tabs {
      margin: 0 auto;
    }
    .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
      border: solid 1px transparent;
      height: 2.2rem;
    }
    .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
      border: solid 1px #007bff;
      height: 2.2rem;
    }
    .jbl-nav-tabs {
      font-size: 14px;
    }
    .nav-item .nav-link {
      padding: 0.5rem .5rem;
    }
  }
  dd.claim-row-data {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
    padding-left: 20px;
  }
  table{
    table-layout: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/views/Claims/View.vue